/*
 * File: InputTime.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/20/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { KeyboardTimePicker } from "@material-ui/pickers";

const InputTime = ({ field, value, error, timeOnChange, parentOnBlur }) => {
  if (value === "") {
    value = null;
  }
  return (
    <KeyboardTimePicker
      error={error}
      onChange={timeOnChange}
      onBlur={parentOnBlur}
      key={field.name}
      id={field.name}
      name={field.name}
      inputVariant="filled"
      value={value}
      label={field.label}
      format={"hh:mm a"}
    />
  );
};

InputTime.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.instanceOf(Date),
  error: PropTypes.bool,
  timeOnChange: PropTypes.func.isRequired,
  parentOnBlur: PropTypes.func
};

export default observer(InputTime);
